import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ProgressDataHarness } from './multi-level-progress-bar.model';
import { delay, of } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-multi-level-progress-bar',
  templateUrl: './multi-level-progress-bar.component.html'
})
export class MultiLevelProgressBarComponent {
  totalValue = 40 as number;
  progressTitle = 'Total Trophies' as string;
  colorsList = [
    { text: 'Gold', code: '#f7d575' },
    { text: 'Silver', code: '#d1d1d1' },
    { text: 'Bronze', code: '#cf956b' }
  ];
  progressData: ProgressDataHarness[] = this.colorsList.map((color) => {
    return {
      value: color.text === 'Gold' ? 4 : color.text === 'Silver' ? 8 : 2,
      name: color.text,
      label: color.text,
      color: color.code,
      maxValue: this.totalValue
    };
  });
  icon = 'icon-diamond' as string;
  isBrowser = true as boolean;
  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  getSumValues(event: Event, item: ProgressDataHarness): void {
    // Here Observale is mandatory without this HTML number Input is not getting reflected with latest value.
    of('Observable To Update HTML').pipe(delay(0)).subscribe(() => {
      let subTotal = 0;
      if (parseInt((event.target as HTMLInputElement).value) > item.maxValue) {
        item.value = item.maxValue;
      }
      if (this.progressData instanceof Array) {
        subTotal = this.progressData.reduce((accumulator, progressData) => progressData.value + accumulator, 0);
      }
      this.progressData.map(val => {
        val.maxValue = this.totalValue - (subTotal - val.value);
      });
    });
  }
}